<app-skeleton *ngIf="loading" variant="text" [count]="8"
  label="Carregando o broadcast" data-testid="broadcast-loading"></app-skeleton>

<div *ngIf="!loading && broadcast">
  <header class="page-head">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
      <div>
        <h1 class="page-head__title">SMS Massivo</h1>
        <p class="page-head__subtitle">Acompanhamento do envio <strong>{{ broadcast.name }}</strong></p>
      </div>
    </div>
    <div class="page-head__actions">
      <a [routerLink]="['/broadcasts', broadcast.id]" class="sf-btn sf-btn--primary" *ngIf="isScheduled">
        <i class="fa fa-pencil"></i> Alterar
      </a>
      <a [routerLink]="['/broadcasts']" class="sf-btn sf-btn--secondary">
        <i class="fa fa-chevron-left"></i> Voltar
      </a>
      <a [routerLink]="['/broadcasts/new']" class="sf-btn sf-btn--secondary">
        Criar envio em massa <i class="fa fa-paper-plane-o"></i>
      </a>
    </div>
  </header>

  <div class="notice notice--success" *ngIf="isImporting">
    <i class="fa fa-info-circle"></i>
    <div class="notice__body">
      Os Leads deste Broadcast estão sendo importados. Assim que finalizar você será notificado.
    </div>
  </div>

  <div class="kpis">
    <div class="kpi">
      <h4><i class="fa fa-users ic"></i> Total de leads</h4>
      <b>{{ broadcast.leads_count }}</b>
      <small *ngIf="isAdministrator">{{ broadcast.invalid_leads_count }} higienizados</small>
    </div>
    <div class="kpi ok">
      <h4><i class="fa fa-paper-plane-o ic"></i> Total enviado</h4>
      <b>{{ broadcast.total_sent }}</b>
    </div>
    <div class="kpi" [class.danger]="broadcast.total_errors">
      <h4><i class="fa fa-exclamation-triangle ic"></i> Total de erros</h4>
      <b>{{ broadcast.total_errors }}</b>
    </div>
    <div class="kpi" [class.warn]="waitingCount > 0 && !isCancelled">
      <h4><i class="fa fa-hourglass-half ic"></i> Total aguardando envio</h4>
      <b>{{ isCancelled ? 0 : waitingCount }}</b>
      <small>leads − enviados − erros</small>
    </div>
    <div class="kpi cool" *ngIf="broadcast.short_url">
      <h4><i class="fa fa-link ic"></i> Total clicks</h4>
      <b>{{ broadcast.clicks || 0 }}</b>
      <small>no link encurtado</small>
    </div>
  </div>

  <div class="sf-card">
    <h5 class="card-section-title">
      <i class="fa fa-info-circle"></i> Dados do envio
      <span class="right">
        <span class="status-pill" [ngClass]="'status-pill--' + statusTone">{{ broadcast.broadcast_status_id | broadcastStatus }}</span>
      </span>
    </h5>
    <dl class="def-grid">
      <div class="def"><dt>Campanha</dt><dd>{{ broadcast.name }}</dd></div>
      <div class="def"><dt>Data/Hora do envio</dt><dd>{{ broadcast.scheduled_date | date : 'dd/MM/yyyy, H:mm' }}</dd></div>
      <div class="def">
        <dt>Status</dt>
        <dd><span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + statusTone">{{ broadcast.broadcast_status_id | broadcastStatus }}</span></dd>
      </div>
      <div class="def">
        <dt>Envio</dt>
        <dd>
          <span class="bind-chip" [class.bind-chip--numbers]="!broadcast.leadList">
            <i class="fa" [class.fa-list-ul]="broadcast.leadList" [class.fa-hashtag]="!broadcast.leadList"></i>
            {{ broadcast.leadList ? "Para lista · " + broadcast.leadList.name : "Para números" }}
          </span>
        </dd>
      </div>

      <div class="def wide" *ngIf="broadcast.url">
        <dt>URL</dt>
        <dd>
          <span class="copy-field">
            <input type="text" class="form-control" readonly id="url" [value]="broadcast.url" (click)="copyUrl()" title="Clique para copiar" />
            <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" title="Copiar" (click)="copyUrl()"><i class="fa fa-copy"></i></button>
          </span>
        </dd>
      </div>
      <div class="def wide" *ngIf="broadcast.short_url">
        <dt>URL curta</dt>
        <dd>
          <span class="copy-field">
            <input type="text" class="form-control" readonly id="short_url" [value]="broadcast.short_url" (click)="copyShortUrl()" title="Clique para copiar" />
            <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" title="Copiar" (click)="copyShortUrl()"><i class="fa fa-copy"></i></button>
          </span>
        </dd>
      </div>

      <div class="def wide" *ngIf="broadcast.reason">
        <dt>Motivo do cancelamento</dt>
        <dd class="reason-text">{{ broadcast.reason }}</dd>
      </div>

      <div class="def wide">
        <dt>Mensagem</dt>
        <dd><div class="msg-bubble">{{ broadcast.message }}</div></dd>
      </div>
    </dl>
  </div>

  <div class="expired-contacts sf-card empty" *ngIf="laterThan90Days">
    <i class="fa fa-clock-o"></i>
    <p>Os contatos não estão mais disponíveis, pois já se passaram 90 dias desde seu envio.</p>
  </div>

  <ng-container *ngIf="!laterThan90Days">
    <div class="filter-bar">
      <h5 class="card-section-title" style="margin: 0">Contatos</h5>
      <div class="toolbar-right">
        <div class="search-wrap">
          <i class="fa fa-search"></i>
          <input type="text" class="form-control" placeholder="(99) 99999-9999" [(ngModel)]="phone" name="phone" (keyup.enter)="filterByPhone()" />
          <button class="search-go" (click)="filterByPhone()" aria-label="Filtrar por telefone"><i class="fa fa-search"></i></button>
        </div>
        <button *ngIf="TypeNumber" type="button" class="sf-btn sf-btn--secondary sf-btn--sm" data-testid="numbers-toggle" (click)="toggleNumbers()">
          <i class="fa" [class.fa-eye]="showNumbers" [class.fa-list]="!showNumbers"></i>
          {{ showNumbers ? 'Ocultar Contatos' : 'Verificar Contatos' }}
        </button>
      </div>
    </div>

    <!-- Uma página de números por vez, paginada no backend: carregar a lista inteira derrubava a API
         em broadcast grande (erro 500 por memória, 30/09/2026). -->
    <div *ngIf="showNumbers" class="sf-card numbers-container mb-4" data-testid="numbers-panel">
      <textarea id="broadcast-numbers" data-testid="numbers-textarea" class="form-control" rows="8" [value]="numbersText" readonly></textarea>
      <p *ngIf="numbers && numbers.total === 0 && !numbersFailedPage" class="mt-2 mb-0" data-testid="numbers-empty">
        Nenhum contato disponível para este broadcast.
      </p>
      <div class="notice notice--danger notice--sm" *ngIf="numbersFailedPage" data-testid="numbers-error">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body">
          Não foi possível carregar a página {{ numbersFailedPage }} dos contatos.
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" data-testid="numbers-retry" (click)="retryNumbers()">Tentar de novo</button>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap mt-2">
        <button type="button" class="sf-btn sf-btn--secondary me-2" data-testid="numbers-close" (click)="closeNumbers()">Fechar</button>
        <button type="button" class="sf-btn sf-btn--secondary me-3" data-testid="numbers-copy" (click)="copyNumbers()" [disabled]="!numbersText || loadingNumbers">Copiar esta página</button>
        <app-pagination
          *ngIf="numbers"
          data-testid="numbers-pagination"
          [class.numbers-pagination-loading]="loadingNumbers"
          [currentPage]="numbers.current_page"
          [itemsPerPage]="numbers.per_page"
          [totalItems]="numbers.total"
          (pageChanged)="loadNumbers($event)"
        >
        </app-pagination>
      </div>
    </div>

    <app-skeleton *ngIf="loadingContacts" variant="table-row" [count]="8" [columns]="4"
      label="Carregando os contatos" data-testid="contacts-loading"></app-skeleton>

    <div class="sf-card" style="padding: 0 6px" *ngIf="!loadingContacts">
      <table class="table table-hover elevated">
        <thead>
          <tr>
            <th>Telefone</th>
            <th>Mensagem</th>
            <th>Data Envio</th>
            <th>Status</th>
            <th *ngIf="isAdministrator">Provedor</th>
            <th *ngIf="isAdministrator">Status Provedor</th>
          </tr>
        </thead>
        <tbody *ngIf="contacts && contacts.data.length > 0; else notFound">
          <tr *ngFor="let contact of contacts.data">
            <td>{{ contact.phone }}</td>
            <td>{{ contact.message || "-" }}</td>
            <td>
              <span *ngIf="contact.sent_date">{{ contact.sent_date | date : "dd/MM/yyyy, H:mm" }}</span>
              <span *ngIf="!contact.sent_date">-</span>
            </td>
            <td>
              <span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + contactStatusTone(contact)">{{ getStatus(contact) }}</span>
            </td>
            <td *ngIf="isAdministrator">
              {{ providerAccountsNames[contact.provider_account_id] ?? 'Não fornecido' }}
            </td>
            <td *ngIf="isAdministrator">
              {{ getDeliveryStatus(contact) }}
              <!-- Linha extra em vez de coluna nova: só as entregas confirmadas têm a hora, e uma
                   coluna a mais deixaria "—" na maioria das 500 linhas da página. -->
              <small *ngIf="contact.delivered_at" class="d-block text-muted">
                Entregue em {{ contact.delivered_at | date : "dd/MM/yyyy, H:mm:ss" }}
              </small>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #notFound>
      <tbody>
        <tr *ngIf="contacts">
          <td colspan="5">Nenhuma mensagem enviada</td>
        </tr>
      </tbody>
    </ng-template>

    <app-pagination
      *ngIf="!loadingContacts && contacts"
      [currentPage]="contacts.current_page"
      [itemsPerPage]="contacts.per_page"
      [totalItems]="contacts.total"
      (pageChanged)="pageChanged($event)"
    >
    </app-pagination>
  </ng-container>
</div>
